module.exports = __webpack_public_path__ + "img/logo-tagline.e63a9021.svg";